export default {
  close: 'Blisko',
  dataIterator: {
    pageText: '{0} - {1} z {2}',
    noResultsText: 'nie znaleziono pasujacego wyniku',
    loadingText: 'Ładowanie przedmiotów ...',
  },
  dataTable: {
    itemsPerPageText: 'Rzędy na stronie:',
    ariaLabel: {
      sortDescending: ': Posortowane malejąco. Aktywuj, aby usunąć sortowanie.',
      sortAscending: ': Posortowane rosnąco. Aktywuj, aby posortować malejąco.',
      sortNone: ': Nie sortowane. Aktywuj, aby sortować rosnąco.',
    },
    sortBy: 'Sortuj według',
  },
  dataFooter: {
    itemsPerPageText: 'Przedmioty na stronę:',
    itemsPerPageAll: 'Wszystko',
    nextPage: 'Następna strona',
    prevPage: 'Poprzednia strona',
    firstPage: 'Pierwsza strona',
    lastPage: 'Ostatnia strona',
  },
  datePicker: {
    itemsSelected: 'Wybrano {0}',
  },
  noDataText: 'Brak dostępnych danych',
  carousel: {
    prev: 'Poprzedni obraz',
    next: 'Następny obraz',
  },
  calendar: {
    moreEvents: '{0} więcej',
  },
  fileInput: {
    counter: 'Pliki {0}',
    counterSize: '{0} plików (łącznie {1})',
  },
  observation: {
    accumulatedTemperature: 'Efektywna temperatura zintegrowana',
    accumulatedTemperatureList: 'Efektywny zbiorczy wykaz temperatur',
    startDateCalculation: 'Data rozpoczęcia obliczeń',
    endDateCalculation: 'Data zakończenia akumulacji',
    lowerLimitTemperature: 'Dolna granica temperatury',
    registerAndEditAccumulatedTemperaturePoints: 'Rejestracja/edycja punktu do obliczania temperatury skumulowanej',
    period: 'Okres',
    accumulatedLowerLimitTemperature: 'Skumulowana dolna temperatura graniczna',
    deleteAccumulatedTemperatureLocation:
      'Czy na pewno chcesz usunąć punkty obserwacji temperatury zintegrowanej z 「{fieldName}」?',
    soilMoisture: 'Wilgotność gleby',
    soilTemperature: 'temperatura gleby',
    precipitation: 'opady',
    soilMoistureList: 'Wykaz wilgotności gleby',
    maxRegisterCount: '（Do {count} pozycji）',
    soilConditionVeryWet: 'Zawilgocenie',
    soilConditionWet: 'Wilgotny',
    soilConditionDry: 'Suchość',
    soilConditionVeryDry: 'Przesuszanie',
    drainage: 'Uziarnienie gleby',
    registerAndEditSoilMoisturePoints: 'Rejestracja/edycja punktów obliczeniowych wilgotności gleby',
    soilMoistureConditionGood: 'Glina piaszczysta',
    soilMoistureConditionSlightlyBad: 'Glina ilasta',
    soilMoistureConditionBad: 'Glina',
    soilMoistureConditionSandyLoam: 'Glina piaszczysta',
    soilMoistureConditionClayLoam: 'Glina ilasta',
    soilMoistureConditionClay: 'Glina',
    deleteSoilMoistureLocation: 'Czy na pewno chcesz usunąć punkty obserwacji wilgotności gleby w 「{fieldName}」?',
    deletedField: '< Pole zostało usunięte >',
    validateForStartDateBeforeYesterday: 'Data rozpoczęcia musi być co najmniej jeden dzień przed',
    validateForStartEndDateOrder: 'Data końcowa musi być późniejsza niż data początkowa',
    validateForStartEndDuration: 'Daty rozpoczęcia i zakończenia muszą być w ciągu {day} dni od siębie',
    validateForStartNowDuration: 'Data rozpoczęcia musi być w ciągu {day} dni od dnia dzisięjszego',
  },
  caster: {
    rtkInfo: 'Informacje dotyczące korekcji RTK',
    rtkLog: 'Dziennik komunikacji',
    myBaseStationStatus: 'Status mojej stacji bazowej',
    howToSetupRtkBase: 'Podczas wysyłania informacji korekcyjnych z produktu innej firmy do "My Base Station"',
    howToSetupRtkRover:
      'Podczas odbierania informacji korygujących z "Mojej stacji bazowej" za pomocą produktu innej firmy',
    host: 'Host',
    port: 'Port',
    mountpoint: 'Mount Point',
    derivedPassthroughLabel: ' (bez konwersji)',
    derivedPassthroughCaption: 'Przesyła poprawki stacji bazowej bez zmian. Ustawienie standardowe',
    derivedMsm4Label: ' (zgodność)',
    derivedMsm4Caption: 'Konwersja do MSM4: dla odbiorników niestabilnych z najnowszym formatem (np. MSM7)',
    derivedLegacyLabel: ' (dla starszych odbiorników)',
    derivedLegacyCaption: 'Konwersja do starszego formatu 1004/1012: tylko GPS+GLONASS',
    derivedNote:
      'Jeśli poprawki nie są odbierane lub brak FIX, wypróbuj _MSM4 / _LEGACY. Przy stacjach bazowych innych niż AgriBus te wyjścia mogą być niedostępne.',
    baseStation: 'Stacja bazowa',
    rover: 'Rover',
    userId: 'ID użytkownika',
    ntripUserId: 'Ntrip ID użytkownika',
    ntripPassword: 'Ntirp hasło',
    showCaption: 'Pokaż',
    statusTab: 'Status',
    qualityTab: 'Jakość',
    mapTab: 'Mapa',
    logTab: 'Dziennik połączeń',
    settingsTab: 'Ustawienia',
    baseShort: 'Stacja bazowa',
    casterServer: 'Serwer caster',
    roverShort: 'Rover',
    receiving: 'Odbieranie',
    stale: 'Odbiór wstrzymany',
    noConnection: 'Brak połączenia',
    lastReceivedAt: 'Ostatni odbiór',
    disconnectedAt: 'Rozłączono',
    summaryTitle: 'Odbiór stacji bazowej',
    lastSnapshotNote: 'Ostatnie wartości przed rozłączeniem',
    noStatsData: 'Brak danych ze stacji bazowej',
    bytesRate: 'Przepływność',
    messagesPerSecond: 'Wiadomości',
    epochInterval: 'Interwał epoki',
    uptime: 'Czas połączenia',
    decodeErrors: 'Błędy dekodowania',
    basePosition: 'Pozycja bazy',
    antenna: 'Antena',
    satellites: 'Satelity',
    signals: 'Sygnały',
    meanCnr: 'Średni C/N0',
    msgType: 'Wiadomość',
    msgCount: 'Liczba',
    msgInterval: 'Interwał',
    msgLastSeen: 'Ostatni odbiór',
    cnrChart: 'Średni C/N0 (dB-Hz)',
    satsChart: 'Satelity',
    rateChart: 'Przepływność (bajty/s)',
    epochChart: 'Interwał epoki (ms)',
    noHistoryData: 'Brak danych historycznych',
    noTrackData: 'Brak zapisów GGA rovera',
    baseline: 'Linia bazowa',
    fixQuality: 'Jakość fix',
    ggaPoints: 'Zapisane punkty',
    logBaseTitle: 'Połączenia stacji bazowej',
    logRoverTitle: 'Połączenia roverów',
    startAt: 'Początek',
    endAt: 'Koniec',
    inSession: 'Połączono',
    userAgentLabel: 'Klient',
    logNote: 'Pokazuje zapisy z ostatnich 24 godzin',
  },
  print: {
    field: {
      fillSetting: 'Wypełnić pole',
      backgroundWhiteColorSetting: 'Białe tło',
      backgroundNoColorSetting: 'Brak tła',
      printText: 'Druk',
      showFieldName: 'Pokaż nazwę pola',
    },
  },
  sortOptions: {
    title: 'Sortuj według',
    field: {
      name: 'Nazwa pola',
      createdAt: 'Data rejestracji',
      lastModifiedDateTime: 'Zmieniona data',
    },
  },
  fieldElevation: {
    title: 'elewacja',
    cantBuildBecauseNoTask: 'Historia pracy nie istnieje, więc nie jest możliwe stworzenie mapy wysokości.',
    nowBuilding: 'Przygotowywanie... (W zależności od obszaru pola, może to zająć trochę czasu, aby utworzyć).',
    updatedAt: 'Data utworzenia',
    meshSize: 'Rozmiar oczek',
    taskFetchLimit: 'ilość danych',
    taskDateRange: 'Zakres',
    taskPointCount: 'liczba punktów roboczych',
    editButton: 'Edytuj',
    createButton: 'Utwórz stronę',
    needStandardPlan: 'Mapa wysokości wymaga planu standardowego.',
    taskFetchLimitHint:
      'Jeśli nie ma różnicy w wysokości, należy ją zwiększyć. Jeśli występuje duży hałas, należy go zmniejszyć.',
    creationFailedMessage: 'Tworzenie mapy wysokości nie powiodło się.',
    gnssStatus: 'Status GNSS',
    elevationRange: 'Zasięg wysokości',
    optionSetting: 'Ustawienie opcji',
    minValue: 'Wartość minimalna',
    maxValue: 'Wartość maksymalna',
    minIgnoreCaption: 'Wzniesięnia poniżej tej wartości są ignorowane',
    maxIgnoreCaption: 'Wzniesięnia powyżej tej wartości będą ignorowane',
    minValueNeedError: 'Należy ustawić wartość minimalną',
    maxValueNeedError: 'Należy określić wartość maksymalną',
    minValueRangeError: 'Wartość minimalna musi być mniejsza niż wartość maksymalna',
    maxValueRangeError: 'Wartość maksymalna musi być większa niż wartość minimalna',
    invalidOptionSettingError: 'Podano nieprawidłowe ustawienie opcji',
    dateRangeInput: 'Zakres dat',
    oldestTaskDateInput: 'Data początkowa',
    newestTaskDateInput: 'Data końcowa',
  },

  navi: {
    GeneralMainSettingMenuGnssSource: 'Źródło GNSS',
    GeneralMainSettingGnssSourceInternal: 'Wewnętrzny',
    GeneralMainSettingGnssSourceGPlus: 'AgriBus-G+',
    GeneralMainSettingGnssSourceG2: 'AgriBus-G2',
    GeneralMainSettingGnssSourceGMini: 'AgriBus-GMini',
    GeneralMainSettingGnssSourceGMiniR: 'AgriBus-GMiniR',
    GeneralMainSettingGnssSourceUsb: 'USB',
    GeneralMainSettingGnssSourceBluetooth: 'Bluetooth',
    GeneralMainSettingGnssSourceTcpPort: 'TCP Port',
    GeneralMainSettingGnssSourceNtripClient: 'Klient Ntrip (Trimble, Topcon)',
    GeneralMainSettingGnssSourceVirtual: 'Virtual',
  },

  ValidationTextRequired: 'wymagany',
  ResetPasswordTitle: 'Rozpocznij resetowanie hasła',
  ResetPasswordButton: 'Rozpocznij resetowanie',
  ResetPasswordDescription: 'Otrzymasz wiadomość e-mail zawierającą link umożliwiający zresetowanie hasła.',
  ValidationBadEmail: 'Zły adres e-mail',
  ChangePasswordButton: 'Zmień hasło',
  CreatePasswordButton: 'Stwórz hasło',
  UnitTitle: 'Jednostka',
  UnitMetric: 'Metryczny',
  UnitImperial: 'Cesarski',
  UnitJpUnitsOfArea: 'Japońskie jednostki powierzchni',
  UnitThUnitsOfArea: 'Tajskie jednostki powierzchni',
  NickNameHint: 'Twój nick',
  SendMeNews: 'Wyślij mi wiadomość.',
  FreePlanDisplayName: 'Bezpłatny plan',
  StandardPlanDisplayName: 'Planie Standardowym',
  ChangePasswordTitle: 'Zmień hasło',
  CreatePasswordTitle: 'Stwórz hasło',
  CurrentPasswordHint: 'Aktualne hasło',
  NewPasswordHint: 'nowe hasło',
  SignInButton: 'Zaloguj się',
  ToResetPasswordButton: 'Zapomniałeś hasła',
  DocFormFieldDetailFieldNameHint: 'Nazwa pola',
  DocFormTaskRecordDetailFieldNameHint: 'Nazwa rekordu zadania',
  DocFormTaskRecordDetailDescriptionHint: 'Opis',
  DocFormTabNameTaskRecordList: 'Rejestry zadań',
  DocFormTabNameRefLineList: 'Linie odniesięnia',
  DocFormTabNameGridPointsList: 'Punkty siatki',
  DocFormTabNameFieldList: 'Pola',
  DocFormFieldRegisteredDateFormatBase: 'Zarejestrowany: {createDate}',
  DocFormMenuItemSignOut: 'Wyloguj',
  DocFormFieldDetailDescriptionHint: 'Opis',
  StandardPlanIsNeededDialogMessage: 'Aby korzystać z tej funkcji, wymagana jest subskrypcja Planie Standardowym.',
  SelectPlanDialogTitle: 'Wybierz plan',
  SelectPlanDialogRecommend: 'Zalecane',
  SelectPlanDialogYearPlan: 'Abonament roczny',
  SelectPlanDialogYearPlanGreatValue: '(2 miesiące rabatu)',
  SelectPlanDialogYearMonth: 'Plan miesięczny',
  StandardPlanPriceForMonthBatch: 'Opłata roczna',
  StandardPlanPricePerMonth: '/ Miesiąc',
  StandardPlanPricePerYear: '/ Rok',
  StandardPlanPriceForYearNotice: '* Płatność za 12 miesięcy',
  SelectPlanSubscribeYear: '30-dniowa wersja próbna',
  SelectPlanSubscribeMonth: 'Rozpocznij 30-dniowy okres próbny',
  selectPlanDataViewNote: '* Jeśli nie wznowisz subskrypcji w ciągu około miesiąca po anulowaniu, dane zarejestrowane przed anulowaniem przestaną być wyświetlane (obowiązuje od 1 października 2026 r.). Wyeksportuj potrzebne dane w okresie obowiązywania subskrypcji.',
  DefaultRefLineTypeStraight: 'Linia prosta',
  DefaultRefLineTypeCurved: 'Linia krzywa',

  customSelectAll: 'Zaznacz wszystko',
  customUnSelectAll: 'Odznacz wszystko',
  customRegistration: 'Rejestracja',
  customUpdate: 'Aktualizacja',
  customSearch: 'Szukaj',
  customDelete: 'Usunąć',
  customAllow: 'Dopuszczać',
  customDeny: 'Zaprzeczać',
  customDefault: 'Domyślna',
  customSelected: 'Wybrany',
  customSelectThis: 'Wybierz to',
  customArea: 'Powierzchnia',
  customNotAvailable: 'Niedostępne',
  customEdit: 'Edytować',
  customCancel: 'Anuluj',
  customNone: 'Żaden',
  customClose: 'Blisko',
  customFieldDrawHint: 'Klikaj mape, aby dodac wierzcholki pola, a nastepnie zatwierdz przyciskiem (przycisk cofnij / Backspace usuwa ostatni punkt)',
  customBack: 'Wstecz',
  customRefresh: 'Odświeżać',
  customUpload: 'Przekazać plik',
  customPriceIncludingTax: 'Cena zawiera podatek',
  customPay: 'Zapłacić',
  customCancelContract: 'Anulowanie',
  customConfirmReally: 'Czy jesteś pewny?',
  customRememberMe: 'Zapamiętaj mnie',
  customLogin: 'Zaloguj się',
  customNowLoggingIn: 'Logowanie...',
  customEmail: 'E-mail',
  customPassword: 'Hasło',
  customUser: 'Użytkownik',
  customUserSettings: 'Ustawienia użytkownika',
  customSentEMailMessage: 'Wysłany email.',
  customNewPasswordReInput: 'Zweryfikuj hasło',
  customValidationPasswordMinLength: 'Hasło musi mieć co najmniej {length} znaków',
  customValidationPasswordMaxLength: 'Za długo',
  customValidationPasswordNotMatch: 'Hasła się nie zgadzają',
  customChangePasswordSuccess: 'Twoje hasło zostało zmienione.',
  customGoToLoginPageTitle: 'Wróć do strony logowania',
  customYouDontHaveAccount: 'Nie jesteś użytkownikiem?',
  customRegisterAgriBusWeb: 'Zarejestruj się w AgriBus-Web',
  customChange: 'Zmiana',
  customLanguage: 'Język',
  customSaveAction: 'Zapisać',
  customSaveSuccess: 'Zapisano',
  customAddAction: 'Dodaj',
  customPlan: 'Plan',
  customPlanExpirationDate: 'Data ważności: {expirationDate}',
  customPlanDescription: 'Aby zmienić swój plan, musisz to zrobić z AgriBus-NAVI (aplikacja na Androida).',
  customPlanOnly: 'Ta funkcja wymaga Planie Standardowym',
  customDetail: 'Szczegół',
  customDatePickerNullAlert: 'Najpierw wybierz datę',
  customTaskNotFound: 'Nie znaleziono zadania',
  customTaskNotFoundAtDate: 'Nie znaleziono zadania o godzinie {date}.',
  customErrorInitTasksFreePlan: 'W planie darmowym jest ograniczony do zadań do dwóch dni.',
  customErrorInitTasksNoTasks: 'Wykonaj „Synchronizuj dane” przez AgriBus-NAVI, gdy nie widzisz żadnych zadań.',
  customErrorInitFieldsNoFields:
    'Nie „Synchronizuj dane” przez AgriBus-NAVI lub ŻADNE pola nie zostały zarejestrowane.',
  customColored: 'Kolorowy',
  customHeight: 'Wysokość',
  customHeightMap: 'Mapa wysokości',
  customSpeed: 'Prędkość',
  customDate: 'Data',
  customWorkWidth: 'Szerokość robocza',
  customWorkedArea: 'Obrobiony obszar',
  customOverlappedArea: 'Nakładający się obszar',
  customTaskRecordEfficiency: 'Wydajność',
  customDistance: 'Dystans',
  customWorkedTime: 'Czas pracy',
  customAverageSpeed: 'Średnia prędkość',
  customWorker: 'Pracownik',
  customDocFormTaskRecordDistanceOfFormatBase: '{distance} (Av. {speed})',
  customDocFormTaskRecordWorkedAreaPercentageFormatBase: '{percentage}% z {fieldArea}',
  customDocFormTaskRecordWorkedAreaInfoFormatBase: '{areaPercentageText}, {efficiencyText} / h',
  customPageSuffix: 'strony',
  customDisplayCount: 'Wyświetlane wyniki',
  customTotalCount: 'Razem {count}',
  customListingModeSelf: 'Tylko ja',
  customListingModeAll: 'W tym następujące',
  customIconSettings: 'Ustawienie ikon',
  customAccountHeader: 'KONTO',
  customConnectionHeader: 'ZNAJOMOŚCI',
  customConnectionTitle: 'Znajomości',
  customFollowRequest: 'Postępuj zgodnie z prośbą',
  customFollow: 'Podążać',
  customUnfollow: 'Przestań obserwować',
  customFollowing: 'Następujący',
  customFollower: 'Obserwujący',
  customHaveNoFollowings: 'Nikogo nie śledziłeś',
  customHaveNoFollowers: 'Nie masz obserwujących',
  customInbox: 'W pudełku',
  customOutbox: 'Skrzynka nadawcza',
  customInboxEmpty: 'Pusty',
  customOutboxEmpty: 'Pusty',
  customSendFollowRequest: 'Wyślij żądanie śledzenia',
  customSendFollowRequestMessage: 'Wysłano żądanie śledzenia',
  customFollowRequestSelfRequestError: 'Nie możesz wysłać do siębie żądania śledzenia',
  customAllowFollowRequest: 'Zezwoliłeś na żądanie śledzenia od {fromNickname}',
  customUnfollowMessage: 'Anulowanie obserwowania zakończone.',
  customUpdatedIconMessage: 'Twoja ikona została zaktualizowana',
  customIconNowSelected: 'Teraz wybrane',
  customIcon: 'domyślna ikona',
  customIconSettingsDescription: 'Zalecamy ustawienie własnej ikony.',
  customIconChangeToIcon: 'Zmień na domyślne',
  customGravatarIcon: 'Gravatar',
  customIconSettingsGravatarDescription: 'Jeśli masz ikonę Gravatara, warto ją wybrać.',
  customIconChangeToGravatar: 'Wybierz to',
  customCustomIcon: 'Zwyczaj',
  customIconSettingsCustomDescription: 'Możesz ustawić swoje ulubione zdjęcia. Przygotuj plik JPEG lub PNG.',
  customIconChangeToCustom: 'Wybierz to',
  customIconReUpload: 'Prześlij ponownie',
  customTemperature: 'Temperatura',
  customHumidity: 'Wilgotność',
  customWind: 'Wiatr',
  customPressure: 'Nacisk',
  customSunrise: 'wschód słońca',
  customSunset: 'Zachód słońca',
  customShowAllCropsDescription: 'Pokaż wszystko',
  customShowCurrentCropsDescription: 'Tylko prąd',
  customProduct: 'Przyciąć',
  customProductsNotFound: 'Brak upraw',
  customColor: 'Kolor',
  customYear: 'Rok',
  customCrop: 'Przyciąć',
  customCropVariety: 'Różnorodność',
  customDeleteCropConfirmationMessage:
    '{cropYear} {cropName} {cropVariety} zostanie usunięty. Jesteś pewny ? (Zostaną usunięte wszystkie powiązane dane).',
  customOperationType: 'Operacja',
  customFilter: 'Filtr',
  customOutOfField: 'Poza polem',
  customBillingAndPayment: 'Dane do faktury',
  customBillingMethod: 'Metody Płatności',
  customBillingExistingCard: 'Istniejące karty',
  customBillingAddNewCard: 'Dodaj nową kartę',
  customBillingMethodConfirm: 'Proszę potwierdzić metodę płatności',
  customBillingHistory: 'Historia fakturowania',
  customCreditCard: 'Karta',
  customCreditCardLast4: 'kończąc na',
  customCreditCardNameOnCard: 'Imię na karcie',
  customCreditCardInfo: 'Informacje o karcie',
  customCreditCardAddCard: 'Dodaj kartę',
  customCreditCardAddCardCaution1:
    'Twoja karta nie zostanie w tej chwili obciążona, ale zostanie ustawiona jako domyślna dla przyszłych opłat.',
  customCreditCardAddCardCaution2:
    'Jeśli chciałbyś zapłacić rachunek, skontaktuj się z contact@agri-info-design.com przed rejestracją karty.',
  customCreditCardNoCard: 'Brak kart',
  customMyProducts: 'Moje produkty',
  customMyProductsList: 'Lista produktów',
  customMyProductProduct: 'Produkt',
  customMyProductProductNumber: 'Numer produktu',
  customMyProductDataPlan: 'Plan danych',
  customMyProductDataPlanSubscribe: 'Subskrybuj',
  customMyProductDataPlanSubscribeSuccessMessage: 'Wkrótce będzie dostępna komunikacja 3G z {productNumber}.',
  customMyProductDataPlanExpiredMessage: 'Wygasł w dniu {expiredDate}',
  customMyProductDataPlanCancelConfirmationMessage:
    'Jeśli anulujesz ten plan, komunikacja 3G zostanie zakończona. Ponadto, nawet jeśli ten okres pozostanie, różnica nie zostanie zwrócona. Jednak nawet po anulowaniu możliwe jest ponowne podpisanie planu. Czy jesteś pewny?',
  customRealTime: 'Czas rzeczywisty',
  customRealTimeSettings: 'Ustawienia w czasię rzeczywistym',
  customModel: 'Model',
  customSystemVersion: 'Wersja systemu',
  customWebMarkerIcon: 'Ikona',
  customWebMarkerSetting: 'Ustawienie znacznika',
  customWebMarkerName: 'Nazwa znacznika',
  customWebMarkerColor: 'Kolor znacznika',
  customRealtimeChooseYourDevice: 'Wybierz swoje urządzenie',
  customRealtimeDeviceNotActive: 'Nieaktywny',
  customElevation: 'Wysokość',
  customGnss: 'GNSS',
  customSatellites: 'Satelity',
  customFirmwareVersion: 'Wersja oprogramowania',
  customHasFirmwareUpdate: 'Dostępna aktualizacja',
  customFirmwareDownloadMessage: 'Dostępna jest nowa wersja {newestFirmwareVersion}.',
  customDownload: 'Pobieranie',
  customFieldRegistration: 'Rejestracja w terenie',
  customFieldCreateWithMapTitle: 'Utwórz pole na mapie',
  customFieldCreateWithMapTitleDescription: 'Utwórz nowe pole na mapie',
  customFieldCreateWithMapButton: 'Stwórz',
  customFieldCreateWithMapFieldName: 'Nazwa pola',
  customFieldCreateWithMapLoadingMap: 'Ładowanie mapy ...',
  customFieldCreateWithMapCreate: 'Stwórz',
  customFieldCreateWithMapCreateFinishedMessage: 'Utworzono pole {fieldName}',
  customFieldCreateWithMapCreateErrorMessage: 'Nie udało się utworzyć pola {fieldName}',
  customFieldCreateWithMapNoFieldMessage: 'Utwórz pole na mapie',
  customFieldCreateWithMapNoFieldNameMessage: 'Wpisz nazwę pola',
  customFieldCreateWithMapTooManyFieldsMessage: 'Można utworzyć jedno pole',
  customFieldUploadTitle: 'Prześlij KML / Shapefile',
  customFieldUploadMessage: 'Prześlij plik KML / KMZ lub Shapefile.',
  customFileUploadShapefileDescription:
    'Archiwum ZIP Shapefile musi zawierać co najmniej jeden z następujących typów plików.',
  customFieldUploadFileInput: 'Proszę wybrać plik.',
  customFileUploadShpDescription: '.shp: Geometria',
  customFileUploadShxDescription: '.shx: Indeks geometrii',
  customFileUploadDbfDescription: '.dbf: baza danych atrybutów',
  customFileUploadPrjDescription: '.prj: Informacje o współrzędnych geograficznych.',
  customFileUploadPrjCaution: '.prj jest konieczny do poprawnego odczytania informacji o współrzędnych.',
  customFileUploadTextEncodingDescription: 'Zmień tę wartość, jeśli nazwa atrybutu jest uszkodzona.',
  customFileUploadAttributeNameForFieldName: 'Nazwa atrybutu używana jako nazwa pola',
  customFileUploadFieldImportStart: 'Rozpocznij importowanie pól ({count})',
  customFileUploadImportCheckTitle: 'Import',
  customFileUploadFieldImportStartedMessage:
    'Rozpoczęło się importowanie pól. W przypadku wielu pól może to potrwać kilka minut.',
  customFieldUploadErrorMessage: 'Nie można odczytać przesłanego pliku',
  customFieldThisFieldName: 'Pole „{fieldName}”',
  customFieldUnknownFieldName: 'To pole',
  customFieldNoName: 'Brak pola',
  customFieldDeleteAlertWithTask:
    'Istnieją {count} zadań w {fieldName}. Jeśli to usuniesz, informacje o tych zadaniach zostaną utracone. Czy jesteś pewny?',
  customFieldDeleteAlertWithoutTask: 'Czy na pewno chcesz usunąć {fieldName}?',
  customTextEncoding: 'Kodowanie',
  customFieldImportFinishedMessage: 'Importowanie {count} pól zostało zakończone.',
  customFieldImportErrorMessage: 'Importowanie pól nie powiodło się.',
  customFieldCount: 'Liczba pól: {count}',
  customExport: 'Eksport',
  customTaskExport: 'Eksportowanie zadań',
  customTaskWhatIsAgriBusFormat: 'Format AgriBus to tekst rozdzielany tabulatorami, więc jest łatwy do przetworzenia.',
  customTaskNowDeveloping: 'W rozwoju',
  customTaskNowDevelopingDescription: 'Wkrótce będzie można generować w innych formatach.',
  customTaskStartExporting: 'Rozpocznij eksportowanie',
  customTaskNowExporting: 'Teraz eksportuję ...',
  customTaskDownloadReady: 'Gotowy do pobrania',
  customFieldHeader: 'Pole',
  customDarkMode: 'Tryb ciemny',
  customNewRegistration: 'Nowa rejestracja',
  customCreateNew: 'Utwórz',
  customImport: 'Importuj',
  customListDisplay: 'Wyświetlanie listy',
  customCardDisplay: 'Wyświetlanie kart',
  customCalendarDisplay: 'Wyświetlanie kalendarza',
  customFieldsList: 'Lista pól',
  customPleaseSignUpFromAndroidApplication:
    'Zarejestruj się z aplikacji Android <span class="aid-logotype">AgriBus-NAVI</span>',
  customWhatIsAgribusNAVI: 'Co to jest <span class="aid-logotype">AgriBus-NAVI</span>',
  customAgriBusNAVIDescription:
    '<span class="aid-logotype">AgriBus-NAVI</span> to system nawigacji GPS do montażu na maszynach rolniczych, takich jak ciągniki, kombajny i opryskiwacze samojezdne, aby pomóc w wykonywaniu prostych zadań na polu. Sprawdzenie wyświetlacza podczas jazdy umożliwi utworzenie prostych i równomiernie rozmieszczonych linii na dużych polach.',
  customProductDetails: 'Szczegóły Produktu',
  aid: {
    calendar: {
      month: 'Miesiąc',
      week: 'Tydzień',
      day: 'Dzień',
      fourDays: '4 dni',
    },
  },
  customTaskFilterAllSelect: 'Cała praca',
  customTaskFilterGetError: 'Nie udało się uzyskać informacji o filtrze',
  customTaskFilterPostError: 'Nie udało się zarejestrować informacji o filtrze',
  customTaskFilterPutError: 'Nie udało się zaktualizować informacji o filtrze',
  customTaskFilterDeleteError: 'Nie udało się usunąć informacji o filtrze',
  customTaskFilterPostSucceed: '„{filtername}” zarejestrowana',
  customTaskFilterPutSucceed: '„{filtername}” Został zaktualizowany',
  customTaskFilterSetDefault: 'Ustaw "{filtername}" jako filtr domyślny',
  customTaskFilterDeleteSucceed: 'Informacje o filtrze zostały usunięte',
  customTaskFilterSelectCheckError: 'Odpowiedni filtr nie istnieje. Wybierz filtr',
  customTaskFilterDuplicateCheckError: 'Zduplikowana nazwa filtra',
  customTaskFilterNotEnteredCheckError: 'Nie wprowadzono nazwy filtra',
  customTaskFilterStringNarrowing: 'Zwężenie sznurka',
  customTaskFilterMakeDefault: 'Zawsze używaj tego filtra',
  customTaskFilterName: 'Nazwa filtra',
  customTaskFilterDeleteMsg: '„{filtername}” Czy chcesz usunąć?',
  customTaskFilterDialogTitle1: 'Filtruj historię pracy',
  customTaskFilterDialogTitle2: 'Zastosuj zapisane ustawienia filtrów',
  customTaskFilterCreateNew: 'Utwórz nowe ustawienie filtra',
  customTaskFilterEdit: 'Edycja filtra',
  customTaskFilterSetting: 'Ustawianie filtrów',
  customTaskFilterCurrent: 'Filtr prądu',
  customTaskFilterNoTasksError:
    'Ze względu na ustawienie filtra "{filtername}", liczba wyświetlanych elementów wynosi 0.',
  customTaskFilterAreaZeroHidden: 'Z wyłączeniem prac o zerowym obszarze roboczym',
  customTaskFilterDistanceUnderTenHidden: 'Nie obejmuje prac o przebiegu mniejszym niż 10 m (10,936yd).',
  customTaskFilterNoField: 'Nie ma pola',
  customTaskFilterNoCrop: 'Nie ma uprawy',
  customTaskFilterOutOfFieldHidden: 'Nie obejmuje historii zadań poza polem',
  customSimpleSignUpNow: 'Rejestracja ...',
  customSimpleSignUpSuccess: 'E-mail został wysłany w celu dokończenia rejestracji. Sprawdź swoją skrzynkę pocztową.',
  customEnterpriseInviteSuccess: 'Wysłałem ci zaproszenie mailem.',
  customSimpleSignUpFailed: 'Rejestracja nie powiodła się',
  customSimpleSignUpUserAlreadyExists: 'Wystąpił problem z Twoim adresem e-mail',
  customSimpleSignUpServerError: 'Wystąpił błąd podczas procesu rejestracji',
  customDateFilterStartDate: 'Filtruj datę rozpoczęcia',
  customDateFilterEndDate: 'Filtruj datę zakończenia',
  customDateFilterCalendarType: 'Typ kalendarza',
  customDateFilterCalendarTypeDate: 'Dzień',
  customDateFilterCalendarTypeMonth: 'Miesiąc',
  customDateFilterSetBotton: 'Set',
  customDateFilterRangeError: 'Data rozpoczęcia jest późniejsza niż data zakończenia.Wybierz datę ponownie.',
  customCurrency: 'Waluta',
  customBillingCurrencyJPY: 'Jen japoński',
  customBillingCurrencyUSD: 'dolar',
  customBillingMenu: 'Zarządzanie planem użytkowania',
  customBillingMore: 'Dowiedz się więcej',
  customBillingPurchase: 'Wypróbuj bezpłatną wersję próbną przez 30 dni',
  customBillingPurchaseWithoutTrial: 'Upgrade',
  customBillingPlanInfo: 'Informacje o planie',
  customBillingNowPlan: 'Twój plan',
  customBillingTrial: 'próba',
  customBillingCancellation: 'Anulowanie',
  customBillingContractPeriod: 'Okres obowiązywania umowy',
  customBillingAmount: 'Kwota',
  customBillingAlertMustRegisterCard: 'Aby dokonać zakupu, musisz wcześniej zarejestrować kartę kredytową.',
  customBillingMessageUnsubscribe: 'Płatne plany odwołane.',
  customBillingMessageSubscribe: 'Dziękujemy za twój zakup',
  customBillingMessageUnSubscribeGoogle: 'Obecnie płacisz w Google Play Store. Anuluj z Google Play Store.',
  customBillingReceipt: 'Faktury / rachunki',
  customBillingMessageCancelStandardPlan:
    'Jeśli anulujesz swój płatny plan, nadal będziesz mógł korzystać z usługi przez okres, za który zapłaciłeś. Jeśli anuluję tutaj, będę automatycznie na darmowym planie po {data}, czy to nadal jest poprawne?',
  customBillingMessageCancelTrial:
    'Obecnie jesteś w okresię próbnym, ale jeśli anulujesz swoją subskrypcję tutaj, natychmiast powrócisz do planu darmowego. Należy pamiętać, że po anulowaniu można zapisać się na nowy płatny plan, w którym to przypadku okres próbny nie będzie już obowiązywał.',
  customBillingStandardDescription:
    'Jeden miesiąc gratis z płatnym planem rocznym; skorzystaj ze wszystkich funkcji, w tym z bezterminowego przechowywania danych i wyświetlania pozycji pojazdu w czasię rzeczywistym przez AgriBus-Web, prowadzenia po łuku przez AgriBus-NAVI i zasobnika informacji!',
  customAdRow1_1: 'Rewolucja danych w rolnictwie',
  customAdRow1_2: 'korzystając ze Planie Standardowym',
  customAdRow2_1: 'Trzy korzyści',
  customAdRow2_2: 'Nieograniczone przechowywanie i eksport danych',
  customAdRow2_3: 'Wyświetlanie pozycji pojazdu w czasię rzeczywistym',
  customAdRow2_4: 'Korzystanie z AgriBus-Caster',
  customAdRow3_1: 'Trzy korzyści',
  customAdRow3_2: 'Dodaj różnicę wysokości, prędkość biegu itp. Do toru roboczego',
  customAdRow3_3: 'Zapisz i przywołaj linię bazową wskazówek',
  customAdRow3_4: 'Zastosuj prowadzenie po krzywej',
  customOAuthMessage: 'Podczas uwierzytelniania...',
  customGoogleOAuthBtn: 'Zaloguj się za pomocą Google',
  customGoogleOAuthSignUpBtn: 'Zarejestruj się w Google',
  customOAuthError: 'Błąd w procesię uwierzytelniania OAuth',
  customOAuthGetUserInfoError: 'Wystąpił błąd podczas pobierania informacji OAuth',
  customOAuthServerError: 'Wystąpił błąd w procesię rejestracji poświadczenia OAuth',
  customOAuthFailed: 'Uwierzytelnianie OAuth nie powiodło się',
  customToBillingPage: 'Do standardowego ekranu zakupu planu',
  customTasksListFreePlanMsg:
    'W planie bezpłatnym historia pracy jest wyświetlana tylko przez 2 dni. Subskrybując abonament Planie Standardowym, możesz mieć nieograniczony okres przechowywania.',
  customEnterprise: 'Przedsiębiorstwo',
  customEnterpriseSetting: 'Ustawienia korporacyjne',
  customEnterpriseManagement: 'Zarządzanie przedsiębiorstwem',
  customWhatIsEnterprise: 'Co to jest AgriBus-Web Enterprise?',
  customEnterpriseRegistration: 'Zapisz się do planu Enterprise',
  customPleaseContinueToRegisterForEnterprise:
    'Proszę kontynuować proces rejestracji w AgriBus-Web Enterprise z otrzymanego e-maila.',
  customPleaseInputOrganizationName: 'Proszę wpisać nazwę swojej organizacji.',
  customEnterpriseName: 'Nazwa przedsiębiorstwa',
  customMaxOfMemberThisMonth: 'Maksymalna liczba członków w tym miesiącu',
  customExpectedPaymentAmountForThisMonth: 'Szacunkowa kwota płatności na ten miesiąc',
  customDateOfPayment: 'Data płatności',
  customPaymentHistory: 'Historia płatności',
  customEditEnterpriseName: 'Edycja nazwy przedsiębiorstwa',
  customOrganization: 'Organizacja',
  customOrganizationName: 'Nazwa organizacji',
  customAdministrator: 'Administrator',
  customOrganizationList: 'Schemat organizacyjny',
  customNewOrganization: 'Tworzenie nowej organizacji',
  customCreateOrganization: 'Tworzenie organizacji',
  customEditOrganizationName: 'Edytuj nazwę organizacji',
  customTeam: 'Zespół',
  customTeamList: 'Lista zespołów',
  customMyTeam: 'Mój zespół',
  customMyTeamList: 'Lista mojego zespołu',
  customNewTeam: 'Tworzenie nowego zespołu',
  customTeamName: 'Nazwa zespołu',
  customCreateTeam: 'Stwórzcie zespół',
  customRemoveFromTeam: 'Usunięty z zespołu',
  customEditTeam: 'Edycja zespołowa',
  customMember: 'Członek',
  customMemberName: 'Nazwa członka',
  customAddNewMember: 'Dodaj członka',
  customNumberOfMember: 'Liczba członków',
  customInviteMembers: 'Zaprosić członków',
  customSendInvitationEmail: 'Wyślij zaproszenie na e-mail',
  customPleaseEnterTheNameOfTheMember: 'Proszę wpisać nazwiska członków, których zapraszasz',
  customMemberList: 'Lista członków',
  customEditMember: 'Edytuj Członek',
  customInviting: 'Podczas zaproszenia',
  customRestrictFollow: 'Stosować się do ograniczeń',
  customPermission: 'Prawa dostępu',
  customPermissionName: 'Nazwa upoważnienia dostępu',
  customRoleName: 'Nazwa roli',
  customAction: 'Działanie',
  customIndividualCreation: 'Tworzenie indywidualne',
  customConfirmTeamDeletion: 'Mogę usunąć ten zespół?',
  customConfirmMemberRemovalFromTeam: 'Czy mogę usunąć tego członka z zespołu?',
  customSelectTeamsForMemberToJoinDialogTitle: 'Wybierz zespoły, do których dołączy członek',
  customSelectTeamsForMemberToJoinDialogOK: 'Dodaj do wybranego zespołu',
  customSelectMembersAddToTeamDialogTitle: 'Proszę wybrać członków, którzy dołączą do zespołu',
  customSelectMembersAddToTeamDialogOK: 'Dodaj wybranych członków',
  customFollowMembersDialogTitle: 'Proszę wybrać członka, którego chcesz śledzić',
  customFollowMembersDialogOK: 'Śledź wybranego członka',
  customTeamFollowSelectDialogTitle: 'Proszę wybrać zespół do śledzenia',
  customTeamFollowSelectDialogOK: 'Śledź wybrane zespoły',
  customPleaseConfirm: 'Proszę sprawdzić.',
  customEnterpriseSignUpForPleaseConfirmDescription1:
    'Użytkownik z podanym adresem e-mail znajduje się na Planie Standardowym lub Enterprise.',
  customEnterpriseSignUpForPleaseConfirmDescription2:
    'Jeśli masz Planie Standardowym, zapisz się na plan Enterprise po jego anulowaniu.',
  customEnterpriseSignUpForFreePlanDescription:
    'Użytkownicy z podanym adresem e-mail są na bezpłatnym planie. Czy mogę przejść na plan Enterprise?',
  customEnterpriseSignUpForStandardPlanDescription:
    'Użytkownik o podanym adresię e-mail anulował swój plan standardowy, ale jest on nadal aktywny. Czy chcesz przejść na plan Enterprise? (Proszę zauważyć, że jeśli użytkownik nadal zalega z opłatami za plan Standard, zostanie obciążony opłatami zarówno za plan Standard, jak i Enterprise.)',
  customAddFollowMembers: 'Dodaj kolejnego członka',
  customAddFollowTeams: 'Dodaj następujący zespół',
  customBillingMaxMember: 'Maksymalna liczba członków',
  customCreditCardRegistration: 'Rejestracja karty kredytowej',
  customNext: 'Następnie',
  customGoBackOneStep: 'Wracając do poprzedniego',
  customRestriction: 'Ograniczenie',
  customMemberSuspension: 'Jesteś pewien, że chcesz przestać korzystać z tego członka?',
  customResumeMemberUsage: 'Jesteś pewien, że chcesz wznowić korzystanie z tego członka?',
  customRestart: 'Restart',
  customSuspended: 'Zawieszony',
  customAddToExistingTeam: 'Dodaj do zespołu',
  customFollowFunction: 'Funkcja Follow',
  customAllowToAddAndRemoveFollow: 'Pozwala na dodawanie i usuwanie',
  customAllowToAddAndRemoveFollowDescription: 'Ten członek nie może sam dodawać lub usuwać zwolenników.',
  customNotAllowToAddAndRemoveFollow: 'Nie pozwalaj na dodawanie i usuwanie follow',
  customNotAllowToAddAndRemoveFollowDescription: 'Ten członek może dodawać i usuwać zwolenników.',
  customEnterprisePlanDisplayName: 'Plan przedsiębiorstwa',
  customPricePerMember: 'Cena za członka.',
  customPerMember: 'Na członka',
  customNotesOnPlanSelection:
    'Fakturowana kwota to maksymalna liczba członków w miesiącu rozliczeniowym x cena jednostkowa.',
  customDueDateForFirstRepayment: 'Termin pierwszej spłaty',
  customEnterprisePlanStart: 'Start',
  customUnsubscribeFromEnterprise: 'Wypisać się z planu Enterprise.',
  customReturnAgriBusWeb: 'Powrót do Agri-Bus Web',
  customAboutCreditCardPayment: 'O płatności kartą kredytową',
  customClickHereUnsubscripbeFromEnterprise: 'Kliknij tutaj, aby wypisać się z planu Enterprise.',
  customEnterpriseWithdrawText1:
    'W związku z wycofaniem się z członkostwa, rachunek za ten miesiąc będzie ostatnim rachunkiem za ten miesiąc i nie będą dokonywane dalsze płatności.',
  customEnterpriseWithdrawText2:
    'Będziemy nadal rozwijać każdy produkt z serii AgriBus w przyszłości, więc jeśli masz szansę, proszę spojrzeć jeszcze raz.',
  customEnterpriseWithdrawText3:
    'Chcielibyśmy podziękować Ci za korzystanie z każdego z produktów z serii AgriBus, nawet jeśli było to tylko na chwilę. Dziękujemy za zainteresowanie naszymi produktami.',
  customErrorEnterpriseWithdraw: 'Nie odwołałeś swojego planu Enterprise. Proszę spróbować jeszcze raz.',
  customGuidanceInterval: 'przedział czasowy',
  customWorkingWidth: 'szerokość robocza',
  customRefLineLength: 'długość linii prowadzącej',
  customRefLine: 'linha de referência',
  customExportRefLine: 'Eksport linii bazowej',
  customDirecton: 'Kierunek',
  customShowTaskDetailError:
    'Nie ma żadnej historii pracy; mogła ona być nie zsynchronizowana z AgriBus-NAVI lub usunięta.',
  customFileUploadAttributeNameForRefLineName: 'Nazwa atrybutu, która ma być stosowana jako punkt odniesięnia',
  customFileUploadRefLineImportStart: 'Zacznij przyjmować {count} linii odniesięnia.',
  customFileUploadShapefileDescriptionForRefLines:
    'Shapefile wymaga pliku archiwum zip (skompresowanego) tylko dla następujących plików',
  customFileUploadShpDescriptionForRefLines: 'Swaths.shp (Informacje topograficzne)',
  customFileUploadShxDescriptionForRefLines: 'Swaths.shx (informacje w indeksię)',
  customFileUploadDbfDescriptionForRefLines: 'Swaths.dbf (informacje o atrybutach)',
  customRefLineImportFinishedMessage: 'Udało nam się uchwycić {count} linii odniesięnia.',
  customRefLineImportErrorMessage: 'Nie udało mi się uchwycić punktu odniesięnia.',
  customRefLineAddTitle: 'Nowa linia odniesięnia Rejestracja',
  customRefLineImportTitle: 'Wczytywanie pliku Shapefile',
  customRefLineImportText: 'Prześlij swój plik Shapefile',
  customRefLineImportText2: 'Można importować tylko linie odniesięnia z Trimble CFX-750.',
  customRefLineCreateTitle: 'Stwórz linię bazową na mapie',
  customRefLineCreateText: 'Stwórz linię bazową na mapie',
  customRefLineUploadTitle: 'Przesyłanie linii bazowej',
  customRefLineNameHint: 'nazwa linii odniesięnia',
  customRefLineDeleteAlert: 'Jesteś pewien, że chcesz skasować {refLineName}?',
  customRefLineDeleteUnknownName: 'Ta linia podstawowa',
  customRefLineDeleteKnownName: 'Linia odniesięnia "{refLineName}".',
  customRefLineDeleteError: 'Nie udało się usunąć linii odniesięnia.',
  customThunderstormWithLightRain: 'Burza z lekkim deszczem',
  customThunderstormWithRain: 'Burza z deszczem',
  customThunderstormWithHeavyRain: 'Burza z silnym deszczem',
  customThunderstormWithLightDrizzle: 'Burza z lekką mżawką',
  customThunderstormWithDrizzle: 'Burza z mżawką',
  customThunderstormWithHeavyDrizzle: 'Burza z ciężką mżawką',
  customThunderstormWithHail: 'Burza z Grzmotem',
  customLightDrizzle: 'Mżawka lekka',
  customDrizzle: 'Mżawka',
  customHeavyDrizzle: 'Mżawka Heavy Drizzle',
  customLightRain: 'Lekki deszcz',
  customModerateRain: 'Umiarkowany deszcz',
  customHeavyRain: 'Ulewny deszcz',
  customFreezingRain: 'Zamarzający deszcz',
  customLightShowerRain: 'Lekki deszcz pod prysznicem',
  customShowerRain: 'Deszcz pod prysznicem',
  customHeavyShowerRain: 'Silny deszcz pod prysznicem',
  customLightSnow: 'Lekki śnieg',
  customSnow: 'Snow',
  customHeavySnow: 'Heavy Snow',
  customMixSnowRain: 'Mieszanie śniegu/pociągu',
  customSleet: 'Sleet',
  customHeavySleet: 'Koszulka ciężka',
  customSnowShower: 'Prysznic śnieżny',
  customHeavySnowShower: 'Prysznic ciężkiego śniegu',
  customFlurries: 'Flurry',
  customMist: 'Mgiełka',
  customSmoke: 'Dym',
  customHaze: 'Haze',
  customSandDust: 'Piasek/pyły',
  customFog: 'Mgła',
  customFreezingFog: 'Zamrażanie Mgła',
  customClearSky: 'Czyste niebo',
  customFewClouds: 'Niewiele chmur',
  customScatteredClouds: 'Rozproszone chmury',
  customBrokenClouds: 'Złamane chmury',
  customOvercastClouds: 'Przechmurzone chmury',
  customUnknownPrecipitation: 'Nieznane Opady',
  customWeatherInfoTitle: 'Informacje o pogodzie',
  customWeatherDescriptionTitle: 'Pogoda',
  customWindSpeedTitle: 'prędkość wiatru',
  customTemperatureTitle: 'Temperatura',
  customRelativeHumidityTitle: 'poziom wilgotności',
  customNumOfSatellites: 'liczba satelitów',
  customGnssStatus: 'Status GNSS',
  customLeftRightMisalignment: 'niewspółosiowość',
  customAzimuthShift: 'przesunięcie azymutalne',
  customGradient: 'gradient',
  customTimeOfAcquisition: 'czas nabycia',
  customWorkOverview: 'przegląd pracy',
  customImageStorage: 'przechowywanie obrazów',
  customMapGaugeDescriptionNone: 'Wyświetlane jest wypełnienie pracy bez kodowania kolorami',
  customMapGaugeDescriptionHeight: 'Różnica wysokości pracy wyświetlana jest za pomocą koloru',
  customMapGaugeDescriptionSpeed: 'Szybkość pracy jest wyświetlana przez kolor',
  customMapGaugeDescriptionNumOfSatellites:
    'Liczba satelitów pozycjonujących w momencie wykonywania operacji jest wyświetlana w różnych kolorach.',
  customMapGaugeDescriptionGnssStatus: 'Status GNSS w czasię pracy jest wyświetlany za pomocą kolorów.',
  customMapGaugeDescriptionLeftRightMisalignment:
    'Odchylenie lewo-prawo od prowadzenia podczas pracy jest wyświetlane za pomocą kolorów.',
  customMapGaugeDescriptionAzimuthShift: 'Kolorowy wskaźnik niewspółosiowości i wskazówki podczas pracy',
  customMapGaugeDescriptionGradient:
    'Pochylenie podczas pracy jest wyświetlane w różnych kolorach (G2, GMiniR, tylko Gmini).',
  customPrecipitationTitle: 'Opad',
  customWeathercomTornado: 'Tornado',
  customWeathercomTropicalStorm: 'Burza Tropikalna',
  customWeathercomHurricane: 'Huragan',
  customWeathercomStrongStorms: 'Silne burze',
  customWeathercomThunderstorms: 'Burze z piorunami',
  customWeathercomRainSnow: 'Śnieg deszczowy',
  customWeathercomRainSleet: 'Rain Sleet',
  customWeathercomWintryMix: 'Wintry Mix',
  customWeathercomFreezingDrizzle: 'Mżawka mrożąco-smarująca',
  customWeathercomDrizzle: 'Mżawka',
  customWeathercomFreezingRain: 'Mroźny deszcz',
  customWeathercomShowers: 'Prysznice',
  customWeathercomRain: 'Deszcz',
  customWeathercomFlurries: 'Flurry',
  customWeathercomSnowShowers: 'Prysznice śnieżne',
  customWeathercomBlowingDriftingSnow: 'Dmuchanie Drifting Snow',
  customWeathercomSnow: 'Snow',
  customWeathercomHail: 'Hail',
  customWeathercomSleet: 'Sleet',
  customWeathercomBlowingDustSandstorm: 'Nadmuchiwanie burzy piaskowej',
  customWeathercomFoggy: 'Mglisty',
  customWeathercomHaze: 'Haze',
  customWeathercomSmoke: 'Dym',
  customWeathercomBreezy: 'Breezy',
  customWeathercomWindy: 'Wiatr',
  customWeathercomFrigidIceCrystals: 'Zimne kryształy lodu',
  customWeathercomCloudy: 'Mętny',
  customWeathercomMostlyCloudy: 'Przeważnie mętny',
  customWeathercomPartlyCloudy: 'Częściowo pochmurny',
  customWeathercomClear: 'Jasne',
  customWeathercomSunny: 'Słoneczny',
  customWeathercomFairMostlyClear: 'Całkiem jasno',
  customWeathercomFairMostlySunny: 'Prawie w większości Słoneczny',
  customWeathercomMixedRainandHail: 'Mieszany deszcz i huragan',
  customWeathercomHot: 'Gorący',
  customWeathercomIsolatedThunderstorms: 'Izolowane burze z piorunami',
  customWeathercomScatteredThunderstorms: 'Rozproszone burze z piorunami',
  customWeathercomScatteredShowers: 'Prysznice rozproszone',
  customWeathercomHeavyRain: 'Ulewny deszcz',
  customWeathercomScatteredSnowShowers: 'Prysznice ze śniegiem rozproszonym',
  customWeathercomHeavySnow: 'Heavy Snow',
  customWeathercomBlizzard: 'Blizzard',
  customWeathercomNotAvailable: 'Niedostępne',
  customSharedMountPointSetting: 'Ustawienie punktu montażowego',
  customSharedMountPointSettingTitle:
    'Ustaw punkt montowania stacji referencyjnej RTK, który ma być współdzielony w ramach organizacji.',
  customSharedMountPoint: 'współdzielony punkt montowania',
  customMountPoint: 'punkt mocowania',
  customStatus: 'status',
  customNotSet: 'Nie jest ustawiony.',
  customSelectMountPoint: 'Wybierz punkt montowania',
  customUnsharedMountPoint: 'Nieudostępnione',
  customSelectMountPointTitle: 'Wybierz punkt montowania do udostępnienia',
  customSharedMountPointRemarks1:
    'Punkty mocowania są wydawane, gdy AgriBus-GMiniR jest ustawiony jako stacja referencyjna za pomocą aplikacji AgriBus-GTools. W przypadku korzystania ze stacji referencyjnej innego producenta, należy skorzystać z poniższego linku.',
  customSharedMountPointRemarks2: 'Kliknij tutaj, aby złożyć wniosek.',
  customOnline: 'online',
  customOffline: 'off-line',
  customNotIssued: 'nie wyemitowany',
  customSetItUp: 'Jesteśmy gotowi.',
  customDeActivated: 'Dezaktywowane.',
  customType: 'klasyfikacja',
  customCropIsNotRegistered: 'Uprawa nie jest zarejestrowana.',
  customNameNotRegistered: 'Nazwa niezarejestrowana',

  customGoToPayerManager: 'Otwórz stronę administracyjną',
  customPaymentInfo: 'Informacje dotyczące płatności',
  customProjectInfo: 'Informacje o projekcie',
  customAddProject: 'Dodaj projekt',
  customAddProjectRemarks: 'Proszę podać nazwę projektu i adres e-mail administratora.',
  customProjectName: 'Nazwa projektu',
  customProjectAdminMailAddress: 'Email administratora',
  customStop: 'zawieszenie',
  customStopDialogText: 'Czy chcesz usunąć wybrany projekt?',
  customDone: 'Załatwione.',
  customUpdateDay: 'data aktualizacji',
  customAdminName: 'Nazwisko kierownika',
  customMaxQuantity: 'maksymalna liczba osób',
  customaddProjectSuccess: 'Twój projekt został dodany.',
  customPlantingShowPast: 'Pokaż poprzednie nasadzenia',
  customPlantingHidePast: 'Ukryj poprzednie nasadzenia',
  customPlantingCropDisplayName: 'nazwa wyświetlana uprawy',
  customPlantingCropVarietyName: 'Nazwa odmiany',
  customPlantingSeason: 'Sezon wegetacyjny',
  customPlantingSeasonStartDate: 'Data rozpoczęcia (wymagana)',
  customPlantingSeasonEndDate: 'Data końcowa',
  customPlantingAddCropOption: 'Dodaj opcję uprawy',
  customPlantingRemoveCropOption: 'Usuń opcję uprawy',
  customPlantingCropSelectionRequiredError: 'Musisz wybrać tę opcję. Jeśli nie ma zastosowania, proszę wybrać "Inne".',
  customPlantingOtherCropSelectionRequiredError: 'Musi być wpisane, jeśli wybrano "Inne"',
  customPlantingDeleteConfirmationMessage:
    'Czy na pewno chcesz usunąć {plantingName}? (wszelkie powiązane dane zostaną również usunięte)',
  customPlantingFieldSelectionHint: 'Jeśli nazwa pola nie jest ustawiona, nie pojawi się ona na liście.',

  customTaskDeleteMessage: 'Czy na pewno chcesz usunąć wybraną pracę?',
  customTaskDeleteFailure: 'Nie udało się usunąć wybranego utworu',
  customTaskDeleteSucceed: 'Udało Ci się usunąć wybrany utwór',

  customErrorStartDateRequired: 'Wymagana jest data rozpoczęcia',
  customErrorFieldRequired: 'Działki są niezbędne',

  customAlreadyExistingUser: 'Zarejestrowałeś już swój adres e-mail. Proszę użyć niezarejestrowanego adresu e-mail.',

  customNowProgressRateTitle: 'Postęp prac',
  customNowProgressRateNotField: 'Brak odpowiednich działek',

  customStandardSubscribeErrorMessage:
    'Zakup subskrypcji nie powiódł się. Prosimy o ponowne sprawdzenie wprowadzonych informacji.',
  customStripeCouponText1: 'Kliknij tutaj, aby zrealizować swój voucher',
  customStripeCouponText2: 'Kliknij tutaj, aby uzyskać kod kuponu',

  customUpdatePolygonFailure: 'Nie udało mi się zaktualizować moich działek.',

  customMultiPolygonImportError:
    'Dane zawierające MultiPolygony, które muszą zostać przekonwertowane na Wielokąty, ponieważ MultiPolygony nie są obsługiwane.',

  customSimpleSignUpAndSignInError: 'Wystąpił problem z Twoim adresem e-mail lub hasłem. Proszę sprawdzić.',
  customNewPasswordValidationError: 'Wymagana jest co najmniej jedna mała litera i jedna cyfra.',

  // 2022.12.08
  customSelectPlanSelectPaymentMethodText: 'Wybierz metodę płatności',
  customCardInfoHasNotBeenEnteredError: 'Proszę podać dane karty',
  customNoPaymentMethodSeletedError: 'Nie wybrano żadnej metody płatności.',
  customFreeDashBoardText1: 'Aby zalogować się do AgriBus-Web, wymagana jest subskrypcja płatnego planu (AgriBus Professional).',
  customFreeDashBoardText2: 'Zobacz więcej informacji.',
  customFreeDashBoardText3: 'Uwaga.',
  customFreeDashBoardText4: '',
  customContractPlanTitle: 'Plan umowy',
  customComparePlansText: 'Porównaj plany',
  customUpgradeToPlusText: 'Ulepszenie do Plusa',
  customDowngradeToPlusText: 'Downgrade do Plusa.',
  customUpgradeToProfessionalText: 'Uaktualnienie do wersji AgriBus Professional',
  customBillingBillingText1: 'Anulowany - automatycznie przekształcany w Plan Darmowy po jego wygaśnięciu.',
  customUpgradeConfirematoinText: 'Zrobię upgrade do wersji AgriBus Professional. Czy to jest w porządku z tobą?',
  customDowngradeConfiremationText: 'Obniżymy ocenę do Plusa. Mogę?',
  customBankTransfer: 'przelew bankowy',
  customHome: 'Strona główna',
  customBillingMessageSubscribeGoogle:
    'Masz obecnie subskrypcję Sklepu Google Play; uaktualnij/zmniejsz swoją subskrypcję w Sklepie Google Play',
  customInvoiceReceiptAddresseeTitle: 'Adres faktury/pokwitowania',
  customChangeAddresseeBtnText: 'Zmiana adresu.',
  customBillingEmailAddressTitle: 'Adres e-mail do rozliczeń',
  customChangeBillingEmailAddressText: 'Zmień swój adres e-mail do rozliczeń',
  customCannotDowngradeText: 'Przelewy bankowe nie mogą być zdegradowane do poziomu Plusa.',
  customChangePaymentMethodsToCard: 'Zmiana na płatność kartą',
  customChangePaymentMethodsToCustomerBalance: 'Zmiana na przelew bankowy',
  customChangePaymentMethodToSendInvoiceText: 'Czy mogę zmienić metodę płatności na przelew bankowy?',
  customMapGaugeDescriptionColorCodedFill:
    'Jeśli aplikacja została pomalowana na kolorowo, wyświetlana jest kolorowa historia pracy.',
  customColorCodeFill: 'Wypełnienie kolorem',
  customSelectDefaultIconTitle: 'Proszę wybrać ikonę',
  customImportLimitMessage: 'Maksymalna liczba importów to {limit}.',
  customPresetIcon: {
    title: 'Ustawienie wstępne',
    description: 'Do wyboru jest sześć różnych ustawień wstępnych.',
    btnText: 'Wybór spośród ustawień wstępnych',
  },
  customBulkDeleteCheckboxText: 'masowe usuwanie',
  customBulkDeleteDialogText: 'Czy mogę wykonać zbiorcze usunięcie?',
  customPerimeter: 'Perymetr',
  feed: {
    menu: 'Aktualności',
    title: 'Aktualności',
    description: 'Codzienne regionalne statystyki prac polowych (anonimowe) i wiadomości z regionów upraw.',
    yourArea: 'Aktywność w Twojej okolicy (~33 km)',
    areaFromFields: 'Wykryto na podstawie Twoich pól',
    widerArea: 'Szerszy obszar (~55 km)',
    national: 'Aktywność w całym kraju',
    daily: 'Wczoraj',
    weekly: 'Ostatnie 7 dni',
    monthly: 'Ostatnie 28 dni',
    vsNormal: 'vs norma',
    vsLastYear: 'vs rok temu',
    noData: 'Za mało danych w tej okolicy (zbyt mało prac w pobliżu).',
    noAreaHint: 'Zarejestruj swoje pola, aby zobaczyć statystyki dla Twojej okolicy.',
    nationalFallback: 'Poniżej pokazano statystyki krajowe.',
    upsell: 'Płatne plany dodają okna dzienne i 28-dniowe oraz widok ~55 km.',
    monitorTitle: 'Tygodniowy raport monitora',
    monitorActive: 'Wzorzec obserwacyjny aktywny',
    monitorNone: 'Brak wzorca obserwacyjnego',
    toMarketInsights: 'Otwórz Market Insights',
    loadError: 'Nie udało się wczytać aktualności. Spróbuj ponownie później.',
    disclaimer: 'Aktywność regionalna to anonimowa statystyka, a nie ocena poszczególnych gospodarstw.',
    kindNews: 'Aktualności',
    kindPr: 'PR',
    readMore: 'Czytaj więcej',
    entryDaily: 'Aktywność w dniu {date}',
    entryWeekly: 'Podsumowanie tygodnia (do {date})',
    areaC3: 'Twoja okolica',
    areaC5: 'Szerszy obszar',
    areaJp: 'Cały kraj',
    historyTitle: 'Trend historyczny',
    kindSignal: 'Sygnał',
    shareTitle: 'Udostępnij w aktualnościach',
    share: 'Udostępnij',
    shareVisibility: 'Widoczność',
    visFollowers: 'Tylko obserwujący',
    visNeighborhood: 'Okolica',
    visPublic: 'Publiczne',
    shareRoute: 'Pokaż trasę pracy',
    shareExact: 'Udostępnij dokładną lokalizację (tło mapy)',
    statTime: 'Czas',
    statDistance: 'Dystans',
    statArea: 'Powierzchnia',
    statWidth: 'Szerokość',
    statSpeed: 'Prędkość',
    statGnss: 'GNSS',
    shareComment: 'Komentarz',
    shareSubmit: 'Udostępnij',
    sharePosted: 'Udostępniono',
    shareFailed: 'Nie udało się. Spróbuj ponownie później.',
    consentNote: 'Twój wpis będzie widoczny dla użytkowników w wybranym zakresię. Lokalizacja jest pokazywana tylko jako przybliżony obszar (ok. 11 km).',
    consentLabel: 'Akceptuję warunki udostępniania (art. 15-2)',
    postDelete: 'Usuń',
    postDeleted: 'Wpis usunięty',
    postDeleteConfirm: 'Usunąć ten wpis?',
    report: 'Zgłoś',
    reportTitle: 'Zgłoś wpis',
    reportConfirm: 'Zgłośic ten wpis operatorowi?',
    reportReason: 'Powód (opcjonalnie)',
    reportDone: 'Zgłośzenie wysłane. Dziękujemy',
    visPrivate: 'Tylko ja',
    followRequested: 'Wyslano',
    followAccept: 'Akceptuj',
    followDecline: 'Odrzuc',
    followAccepted: 'Zaakceptowano prośbę o obserwowanie',
    unfollow: 'Przestań obserwować',
    unfollowConfirm: 'Przestac obserwować tego uzytkownika?',
    connectionsHint: 'Wysyłaj prośby o obserwowanie z wpisów. Po akceptacji zobaczysz wpisy tylko dla obserwujących',
    sharePhotos: 'Dodaj zdjęcia (maks. 4)',
    sharePhotosHint: 'Dane lokalizacji (EXIF) są usuwane automatycznie',
    snsShare: 'Udostępnij',
    copyLink: 'Kopiuj link',
    linkCopied: 'Link skopiowany',
    shareOther: 'Inne aplikacje',
    instagramSaved: 'Zapisano obraz karty. Opublikuj go w aplikacji Instagram',
    manualRecords: 'Wpisy ręczne',
    addManualRecord: 'Dodaj wpis ręczny',
    manualChip: 'Ręczny',
    recordStart: 'Poczatek',
    recordEnd: 'Koniec',
    recordMemo: 'Notatka',
    recordDuration: 'Czas pracy (min)',
    recordCreated: 'Dodano wpis',
    recordDeleteConfirm: 'Usunąć ten wpis?',
    noManualRecords: 'Brak wpisów ręcznych',
    poiRecords: 'Punkty POI',
    addPoi: 'Dodaj punkt POI',
    poiTitle: 'Tytuł',
    poiMapHint: 'Kliknij mape, aby wskazac punkt. W przeciwnym razie uzyta zostanie lokalizacja zdjęcia',
    noPoiRecords: 'Brak punktów POI',
    map: 'Mapa',
    mapLayers: 'Warstwy',
    editMode: 'Tryb edycji',
    selected: 'Wybrane',
    mergeSave: 'Zapisz scalone',
    clipDraw: 'Narysuj obszar przycięcia',
    saveAsField: 'Zapisz obszar uprawy jako pole',
    workWidthM: 'Szerokość robocza (m)',
    workName: 'Nazwa',
    workSaved: 'Zapisano rekord pochodny',
    derivedRecords: 'Rekordy pochodne',
    derivedChip: 'Pochodny',
    derivedDeleteConfirm: 'Usunąć ten rekord pochodny?',
    saveRangeAsWork: 'Zapisz wybrany zakres jako rekord pochodny',
    clipByField: 'Przytnij według pola',
    showOnMap: 'Pokaż na mapie',
    editRange: 'Edytuj zakres',
    trajectoryChip: 'GPS',
    derivedRecordsDescription: 'Rekordy pracy sparowane 1:1 z każdą trajektorią. Edytowane i ręczne rekordy również pojawiają się tutaj',
    spatialEdit: 'Przytnij / Zapisz pole',
    vraTitle: 'Mapa VRA',
    vraDescription: 'Generuj mapy stref do zmiennego dawkowania na podstawie satelitarnych wskaźników wegetacji',
    vraGenerate: 'Generuj nową mapę',
    vraIndex: 'Wskaźnik wegetacji',
    vraGridSize: 'Siatka (m)',
    vraDirection: 'Kierunek (stopnie)',
    vraCloudPct: 'Maks. chmury (%)',
    vraImages: 'Użyte obrazy',
    vraFailed: 'Generowanie nie powiodło się. Możliwe, że brak bezchmurnych obrazów w okresię',
    saveFailed: 'Nie udało się zapisać',
    mapSetGenerated: 'Generowanie zakończone',
    fieldValidFromDate: 'Ważne od: {date}',
    fieldDeleteLinked: 'Nie można usunąć {fieldName}, ponieważ jest powiązane z następującymi danymi.',
    fieldDeleteLinkedTasks: 'Zapisy pracy: {count}',
    fieldDeleteLinkedSets: 'Zestawy pól: {names}',
    fieldDeleteLinkedHint: 'Aby usunąć, najpierw usuń powiązane zapisy pracy i zestawy pól.',
    elevSource: 'Źródło',
    elevSourceDem: 'Satelita (DEM)',
    elevSourceGnss: 'Historia pracy (GNSS)',
    elevCenter: 'Środek skali',
    elevCenterMean: 'Średnia',
    elevCenterMedian: 'Mediana',
    elevCenterValue: 'Wysokość środka',
    elevCustom: 'Własne',
    elevRange: 'Zakres skali',
    elevRangeWidth: 'Szerokość zakresu',
    elevContour: 'Poziomice',
    zoneBands: 'Strefy',
    zonePalette: 'Color scheme',
    paletteHue: 'HSI (green→yellow→red)',
    paletteYlgn: 'Yellow→Green',
    paletteGnrd: 'Green→Red',
    reclassifyTitle: 'Zmień strefy/kolory (bez ponownego generowania)',
    reclassifyApply: 'Zastosuj reklasyfikację',
    followByEmail: 'Prośba o obserwowanie przez e-mail',
    emailUserNotFound: 'Nie znaleziono użytkownika o tym adresie e-mail',
    followRequestSent: 'Wysłano prośbę o obserwowanie',
    eventSettingsTitle: 'Feed settings (auto events)',
    eventSettingsVisibility: 'Event visibility',
    eventSettingsLocation: 'Location visibility',
    eventSettingsSnsStrip: 'Strip exact location when sharing to SNS (default)',
    eventSettingsPrefs: 'Events posted to your feed',
    locHidden: 'Hidden',
    locApprox: 'Approximate (~10 km grid)',
    locExact: 'Include exact location',
    event_work_start: 'Work started',
    event_work_end: 'Work finished',
    event_field_enter: 'Entered field',
    event_field_exit: 'Left field',
    event_poi_added: 'POI added',
    event_vra_map_added: 'VRA map added',
    event_elevation_map_added: 'Height map added',
    event_refline_added: 'Guidance line added',
    event_field_added: 'Field added',
    event_field_set_added: 'Field set added',
    event_work_start_text: 'started working ({name})',
    event_work_end_text: 'finished working ({name})',
    event_field_enter_text: 'entered field \u201c{name}\u201d',
    event_field_exit_text: 'left field \u201c{name}\u201d',
    event_poi_added_text: 'added POI \u201c{name}\u201d',
    event_vra_map_added_text: 'created VRA map \u201c{name}\u201d',
    event_elevation_map_added_text: 'created height map \u201c{name}\u201d',
    event_refline_added_text: 'added guidance lines ({name})',
    event_field_added_text: 'added field \u201c{name}\u201d',
    event_field_set_added_text: 'created field set \u201c{name}\u201d',
    vraNameAuto: 'Nazwa (puste = automatycznie)',
    eventPrefOff: 'Do not post',
    visEditTitle: 'Change visibility',
    visEditLocationExact: 'Show exact location (map background)',
    visEditRemoveLocation: 'Remove exact location',
    visEditPublicNote: 'Exact location is automatically excluded for public posts',
    consentRequiredToShare: 'Sharing requires consent to the sharing terms. Enable sharing from a regular post first',
    elevGnssFailed: 'Obliczenie wysokości nie powiodło się. Brak historii pracy (wysokości GNSS) pasującej do filtrów lub nadal trwa przetwarzanie. Poluzuj filtr GNSS lub zakres dat',
    elevDescription: 'Twórz mapy wysokości pól z wysokości GNSS z historii pracy (zalecane RTK). Bez historii dostępne są satelitarne dane wysokościowe (DEM). Synchronizacja z NAVI jak mapy VRA',
    fieldValidUntil: 'Ważne do: {date}',
    mapSetGeneratedWithCount: 'Utworzono {created} / niepowodzenia {failed} (istniejące mapy tych samych pól są zastępowane)',
    vraGenerating: 'Analizowanie obrazów satelitarnych...',
    vraObsDate: 'Data obserwacji',
    vraPeriodMean: 'Średnia okresu',
    vraLimitReached: 'Osiągnięto limit generowania (Free: 3 łącznie, plany płatne: 10 dziennie)',
    vraExport: 'Eksportuj ISOXML',
    vraModeGrid: 'Siatka (grid)',
    vraModePolygon: 'Poligon',
    vraRate: 'Dawka (kg/ha)',
    vraCellSize: 'Rozmiar komórki (m)',
    vraEditMap: 'Edytuj',
    mapSets: 'Zestawy pól',
    mapSetDescription: 'Grupuj pola filtrem (okres ważności, uprawa, nazwa). Używane m.in. do zbiorczego generowania map VRA',
    mapSetCreate: 'Utwórz zestaw pól',
    fieldSetEmpty: 'Brak zestawów pól',
    mapSetTargetDate: 'Data docelowa',
    mapSetCrop: 'Uprawa',
    mapSetNameContains: 'Nazwa pola (zawiera)',
    mapSetMemoContains: 'Notatka (zawiera)',
    mapSetPreviewCount: 'Pasujące pola',
    mapSetGenerate: 'Generuj/Aktualizuj',
    mapSetFields: 'Pola',
    mapSetLastGenerated: 'Ostatnio wygenerowano',
    fieldAttrsTitle: 'Atrybuty pola (ważność i uprawa)',
    fieldValidFrom: 'Ważne od (puste = bez limitu)',
    fieldValidTo: 'Ważne do (puste = bez limitu)',
    mapSetNoMatch: 'Żadne pole nie pasuje do filtra',
    mapSetDeleteConfirm: 'Usunąć ten zestaw pól i wygenerowane z niego mapy VRA?',
    trajectories: 'Trajektorie',
  },
  marketInsights: {
    menu: 'Informacje rynkowe',
    title: 'Informacje rynkowe (AgriBus-DWH)',
    description: 'Codziennie sprawdzaj postęp prac i obserwacje rynkowe z głównych regionów upraw soi i pszenicy na świecie. To korzyść dla członków: Twoje dane o pracach (statystyki anonimowe) wracają do Ciebie jako informacje pomocne np. przy decyzji o sprzedaży.',
    soybeanDescription: 'Stan upraw i sygnały rynkowe w regionach sojowych Brazylii i USA',
    wheatDescription: 'Stan upraw i sygnały rynkowe w regionach pszenicznych',
    open: 'Otwórz',
    upsell: 'Informacje rynkowe to korzyść dla członków z planem płatnym. Z planem płatnym możesz je przeglądać bez dodatkowych opłat.',
    memberNote: 'Podczas przeglądania jako członek w lewym górnym rogu monitora wyświetla się odznaka. Te informacje nie stanowią rekomendacji inwestycyjnej.',
  },
}
